/* eslint-disable internal-rules/no-restricted-design-system-props */
/* eslint-disable internal-rules/no-restricted-design-system-imports */
import type { HTMLAttributes } from 'react';

import { Separator, Text } from '@change/ds-core-ui/next';

import { EmbeddedMedia as EmbeddedMediaSunrise } from 'src/app/shared/components/embeddedMediaSunrise';
import { Html } from 'src/app/shared/components/html';

import { Actions } from './components/Actions';
import { ShareLinks } from './components/ShareLinks';
import { StarterActions } from './components/StarterActions';
import { usePageBody } from './hooks/usePageBody';

export function PageBody(props: HTMLAttributes<HTMLDivElement>) {
	const {
		data: { description, creationDate, embeddedMedia },
	} = usePageBody();

	return (
		<div className="mt-8 px-4 sm:px-2" {...props}>
			<div>
				<Text variant="body" fontWeight="normal">
					{creationDate}
				</Text>
			</div>

			<div className="mb-6 mt-2 md:mb-[52px]" data-qa="dm-response-description">
				<Text variant="body" as="span" fontWeight="normal" size="medium" expressive>
					<Html as="span" noContentStyles html={description} />
				</Text>
			</div>
			{embeddedMedia?.html && (
				<EmbeddedMediaSunrise
					html={embeddedMedia.html}
					aspectRatio={embeddedMedia.aspectRatio || undefined}
					className="mt-4 [&>iframe]:w-full md:[&>iframe]:w-[600px]"
					data-qa="embedded-media"
				/>
			)}
			<Actions />
			<Separator orientation="horizontal" className="mb-6 mt-6 md:mt-[52px]" />
			<ShareLinks />
			<StarterActions />
		</div>
	);
}
